(function () {
  const layoutSelector = '[data-desktop-filter-layout]';
  const toolbarSelector = '[data-desktop-filter-toolbar]';
  const toggleSelector = '[data-desktop-filter-toggle]';
  const viewMoreSelector = '[data-desktop-filter-view-more]';
  const storagePrefix = 'collection-desktop-filter-collapsed:';

  function storageKey() {
    return `${storagePrefix}${window.location.pathname}`;
  }

  function getSection(element) {
    return element.closest('.collection-section');
  }

  function getStoredCollapsed() {
    try {
      return window.sessionStorage.getItem(storageKey()) === 'true';
    } catch (error) {
      return false;
    }
  }

  function storeCollapsed(collapsed) {
    try {
      window.sessionStorage.setItem(storageKey(), collapsed ? 'true' : 'false');
    } catch (error) {
      // Storage can be unavailable in private browsing; the in-page state still works.
    }
  }

  function setCollapsed(section, collapsed) {
    const layout = section.querySelector(layoutSelector);
    const toolbar = section.querySelector(toolbarSelector);
    const toggle = section.querySelector(toggleSelector);

    if (!layout || !toolbar || !toggle) return;

    layout.classList.toggle('is-filter-collapsed', collapsed);
    toolbar.classList.toggle('is-filter-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function initSection(section) {
    if (!section || section.dataset.desktopFiltersInitialized === 'true') return;

    setCollapsed(section, getStoredCollapsed());
    section.dataset.desktopFiltersInitialized = 'true';
  }

  function init(root = document) {
    root.querySelectorAll('.collection-section').forEach(initSection);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);

    if (toggle) {
      const section = getSection(toggle);
      const layout = section && section.querySelector(layoutSelector);

      if (!section || !layout) return;

      const collapsed = !layout.classList.contains('is-filter-collapsed');
      setCollapsed(section, collapsed);
      storeCollapsed(collapsed);
      return;
    }

    const viewMoreButton = event.target.closest(viewMoreSelector);

    if (viewMoreButton) {
      const filterSection = viewMoreButton.closest('[data-desktop-filter-section]');
      if (!filterSection) return;

      const expanded = !filterSection.classList.contains('is-options-expanded');
      filterSection.classList.toggle('is-options-expanded', expanded);
      viewMoreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      viewMoreButton.textContent = expanded ? '- View less' : '+ View more';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
